import styles from './Partner.module.scss';
import icon from '../../resources/icons/sber-green.png';
import iconWhite from '../../resources/icons/sber-white.png';

export const Partner = ({color = 'green'}) => {
    return (
        <a href={`http://www.sberbank.ru/ru/person/investments/values/omsc?utm_source=2x2.ru&utm_medium=cpc&utm_campaign=oms_specialproject_person_sp_dec-2022`} className={styles.link} target="_blank" rel="nofollow noreferrer">
            <img src={color === 'white' ? iconWhite : icon}
                 className={styles.partner}
                 alt="Сбербанк"
            />
        </a>
    );
};
